<template>
  <div class="container">
    <div class="bg">
      <img src="../assets/img/img.png" alt="" class="img" />
      <img src="../assets/logoImg.png" alt="" class="logo" />
      <div class="text">E园通</div>
      <div
        class="ad"
        @click="
          appDown('http://in.whkxzy.com/dhgxportal/static/APP/dhgx.apk')
        "
      >
        <img class="icon" src="../assets/img/ad.png" alt="" />
        <div class="wz">Android下载</div>
      </div>
      <div
        class="ios"
        @click="iosDown('https://apps.apple.com/us/app/e-space/id1598315920')"
      >
        <img class="icon2" src="../assets/img/ios.png" alt="" />
        <div class="wz">iPhone下载</div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block">
          <p>点击右上角菜单，</p>
          <p>在浏览器中打开链接</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Overlay } from 'vant'

Vue.use(Overlay)
export default {
  name: 'AppstaticIndex',

  data() {
    return {
      show: false,
    }
  },

  mounted() {},

  methods: {
    appDown(url) {
      this.show = true
      location.href = url
    },
    iosDown(url) {
      this.show = true
      location.href = url
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  box-sizing: border-box;
  min-width: 375px;
  height: 100vh;
  background-image: url('../assets/img/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.bg {
  box-sizing: border-box;
  min-width: 375px;
  height: 100%;
  margin-bottom: 0;
  text-align: center;
}
.img {
  box-sizing: border-box;
  width: 100%;
  height: 297px;
  margin: 62px 12px 32px 12px;
}
.logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 385px;
  box-sizing: border-box;
  width: 103px;
  height: 103px;
}
.text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 495px;
  box-sizing: border-box;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  margin-bottom: 15px;
}
.ad,
.ios {
  position: absolute;
  // right: 50%;
  left: 50%;
  transform: translateX(-50%);
  // bottom: 80px;
  top: 525px;
  width: 178px;
  height: 46px;
  // line-height: 46px;
  border-radius: 23px;
  border: 1px solid #ffffff;
  // margin-bottom: 12px;
  // margin-left: 99px;
  text-align: left;
}
.ios {
  top: 575px;
  // bottom: 20px;
  // margin-bottom: 20px;
}

.icon,
.icon2 {
  box-sizing: border-box;
  display: inline-block;
  width: 24px;
  height: 27px;
  margin-right: 10px;
  margin-left: 20px;
  vertical-align: middle;
}
.icon2 {
  height: 29px;
  // margin-right: 22px;
}
.wz {
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  vertical-align: middle;
  line-height: 46px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
}

.block {
  text-align: center;
  color: #fff;
  line-height: 30px;
  font-size: 18px;
  letter-spacing: 2px;
  padding-bottom: 220px;
}
</style>
